module.exports = __webpack_public_path__ + "static/media/roller_coaster.8d5ed522.mp4";